import type { Technique } from '../types';
import { HALFTONE_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type HalftoneState } from './render';

export const halftone: Technique<HalftoneState> = {
  id: 'halftone',
  name: 'Halftone-Raster',
  category: 'deconstruction',
  description: 'Druckraster aus dem Textfeld — wahlweise nach Deckung oder nach Distanz, mit CMYK-Simulation.',
  params: HALFTONE_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
